<template>
    <!--底部展示-->
    <div class="container-fluid dibu mt-2">
        <div class="text-align-centerb  z-f-sm text-center py-3">
            <div class="gg">
                共计用户：<span>{{ currentUserCount }}</span>人； 统计时间：<span>{{ currentTime }}</span>
            </div>
            <p class="ben mb-2">联系Email：yufenglou321@gmail.com</p>
            <p class="ben mb-0">本站所有內容来自网友分享，如有侵犯到您的权益或者隐私，请来信告知，我们会第一时间处理。</p>
            <p class="ben mb-2">未经当事人同意或以恶作剧方式将当事人隐私发布到平台的用户，一经查实，平台将永久封禁你的账户和IP。</p>
            <p class="feng ">Copyright © 2015 御凤楼.com All rights reserved. </p>
        </div>
    </div>
    <!--底部展示-->
</template>

<script>
    export default {
        name: "ZhaiFoot",
        data() {
            return {
                currentTime: "拉取中...", // 初始化为 "拉取中..."
              userCounts: [147886, 157899, 261897, 141902, 262103], // 固定用户数量列表
              currentUserIndex: 0, // 当前用户数量的索引
              currentUserCount: 245678, // 初始化显示第一个用户数量
            };
        },
        methods: {
          updateTime() {
            const time = new Date();
            // 获取时间并格式化为 YYYY年MM月DD日 HH:MM
            const timeInfo = `${time.getFullYear()}年${(time.getMonth() + 1)
                .toString()
                .padStart(2, "0")}月${time
                .getDate()
                .toString()
                .padStart(2, "0")}日 ${time
                .getHours()
                .toString()
                .padStart(2, "0")}:${time
                .getMinutes()
                .toString()
                .padStart(2, "0")}`;

            this.currentTime = timeInfo;
          },
            updateUserCount() {
                // 每次切换到下一个用户数量
                this.currentUserIndex = (this.currentUserIndex + 1) % this.userCounts.length;
                this.currentUserCount = this.userCounts[this.currentUserIndex];
            },
        },
        mounted() {
            this.updateTime(); // 页面加载时，立即更新时间
            this.updateUserCount(); // 页面加载时，初始化用户数量
            setInterval(this.updateTime, 1000); // 每秒更新一次时间
            setInterval(this.updateUserCount, 3600 * 1000); // 每小时切换一次用户数量
        },
    };
</script>

<style scoped>

    .ben{
        color: white!important;
        font-size: 0.9rem;
    }
    .gg{
        margin-bottom: 0.7rem;
        color: #01ad65;
        font-size: 0.8rem;
    }
    .feng{
        font-size: 0.8rem;
        color: white!important;
    }
</style>
